import styled, { css } from 'styled-components';
import { plainTextStyle, body2 } from '@westwing/ui-kit/typography';
import { forDesktop, forIE, forTablet } from '@westwing/ui-kit/breakPoints';
import Search from '@westwing/ui-kit/Icons/SearchIcon';

export const SearchInputBoxLayout = styled.div<{ isSearchOverlayActive: boolean }>`
    display: grid;
    grid-template: 'input icon' 34px / 1fr 30px;
    justify-items: center;
    align-items: center;
    width: 100%;
    position: relative;

    ${({ isSearchOverlayActive }) =>
        isSearchOverlayActive
            ? css`
                  ${body2}
                  width: 100%;
                  grid-template-rows: 52px;
                  align-items: center;
                  padding: 0 13px 0 20px;
                  border: none;
                  background: ${({ theme }) => theme.colors.charcoal2};
              `
            : ''}

    ${forDesktop`
        width: 287px;
        background: none;
        border-bottom: 1px solid rgb(50, 50, 50);
        padding: 0;
        margin: 0 auto;
        grid-template-rows: 34px;
    `}

    ${forIE`
        display: flex;
    `}
`;

export const Input = styled.input<{ isSearchOverlayActive: boolean; isSearchFocused?: boolean }>`
    ${plainTextStyle}
    line-height: 19.6px;
    width: 100%;
    border: none;
    background: transparent;
    ::placeholder {
        color: ${({ isSearchFocused, theme }) => (isSearchFocused ? 'transparent' : theme.colors.charcoal60)};
    }
    ${({ isSearchOverlayActive }) =>
        isSearchOverlayActive
            ? css`
                  appearance: none;
                  background: ${({ theme }) => theme.colors.charcoal2};
              `
            : ''}

    ${forTablet`
        color: ${({ theme }) => theme.colors.charcoal100};
        display: block;
    `}
  ${({ isSearchOverlayActive }) =>
        isSearchOverlayActive
            ? css`
                  ${forDesktop`
        background: ${({ theme }) => theme.colors.white};
      `}
              `
            : ''}
`;

export const SearchIcon = styled(Search)`
    margin-top: 5px;
    color: ${({ theme }) => theme.colors.charcoal100};

    ${forDesktop`
        margin-top: 0;
        margin-right: -15px;
        display: block;
    `}
    ${forTablet`
        opacity: 1;
    `}
    ${forIE`
        -ms-grid-column: 2;
    `}
`;

export const StyledForm = styled.form<{ isSearchOverlayActive: boolean }>`
    grid-area: input;
    width: 100%;
    display: ${({ isSearchOverlayActive }) => (isSearchOverlayActive ? 'block' : 'none')};

    ${forDesktop`
        display: block;
    `}

    ${forIE`
        -ms-grid-column: 1;
    `}
`;

export const ClearInputIcon = styled.div`
    margin-right: 5px;
    ${forDesktop`
        padding: 8px;
        margin-right: -15px;
        cursor: pointer;
    `}
`;
